import { useState } from "react";
import { FormModal } from "../../components/Forms/FormModal";
import { useForm } from "react-hook-form";
import { useInvoice } from "../../hooks/useInvoice";
import { showToast } from "../../utils";
import { Upload } from 'antd';
import { FolderIcon } from "../../styles/icons/FolderIcon";
import { Flex, Heading, Stack, Text } from "@chakra-ui/react";
import { AxiosError } from "axios";
import { UploadIcon } from "../../styles/icons/UploadIcon";

interface CreateInvoiceForm {
    isOpen: boolean;
    onClose: () => void;
}

interface ErrorsApiProps {
    code: string;
    description: string;
    title: string;
}

export function ImportInvoiceForm({ isOpen, onClose }: CreateInvoiceForm) {
    const { postImportInvoice } = useInvoice();
    const [isLoading, setIsLoading] = useState(false);
    const [file, setFile] = useState<File | null>();
    const [filesList, setFilesList] = useState<any>();
    const { handleSubmit } = useForm({});
    const { Dragger } = Upload;
    const [status, setStatus] = useState("");
    const [errors, setErros] = useState<ErrorsApiProps[]>([]);
    const [disableButtonImport, setDisableButtonImport] = useState(false);

    async function handleOnCloseModal() {
        setFile(null);
        setFilesList(null);
        setErros([]);
        setStatus("");
        onClose();
    }

    async function handleImportCsv() {
        if (disableButtonImport) return;
        setDisableButtonImport(true);
        if (file) {
          let fileExtension = file.name.split(".")[1];
          if (fileExtension !== "csv") {
            setErros([
              {
                code: "403",
                description: "Extensao do arquivo nao suportada.",
                title: "",
              },
            ]);
            setFile(null);
            setFilesList(null);
            return;
          }
          try {
            setIsLoading(true);
            setErros([]);
            setStatus("");
            await postImportInvoice(file);
            setStatus("success");
          } catch (error: any) {
            error?.response?.data?.errors?.map((error:any) => (
              showToast({
                type: "error",
                message: `${error?.code} - ${error?.description}`
              })
            ));
            const err = error as AxiosError;
            setErros(err?.response?.data?.errors);
          } finally {
            setFile(null);
            setFilesList(null);
            setIsLoading(false);
            setDisableButtonImport(false);
          }
        }
    }
    const props = {
        accept: ".csv",
        onRemove: () => {
          setFile(null);
          setFilesList(null);
        },
        beforeUpload: (file: any) => {
          setFile(file);
          return false;
        },
        fileList: filesList,
        file,
    };
    return(
        <FormModal
            title="Emitir NF por .CSV"
            isOpen={isOpen}
            onClose={handleOnCloseModal}
            isSubmitting={isLoading}
            handleConfirmModal={handleSubmit(handleImportCsv)}
            confirmationButtonText="Gerar NF"
            width="650px"
            isAllowToSubmit
        >
            <Dragger {...props} maxCount={1}>
                {!!file ? (
                    <Flex 
                        w="100%"
                        justify="center"
                        align="center"
                        gap="4"
                        direction="column"
                    >
                        <UploadIcon size={76}/>
                        <Text>Upload: {file.name}</Text>
                    </Flex>
                ) : (
                    <Flex 
                        w="100%"
                        justify="center"
                        align="center"
                        gap="4"
                        direction="column"
                    >
                        <FolderIcon size={36} />
                        <Text>Arraste o arquivo para esta área para carregar</Text>
                        <Text>ou</Text>
                        <Text 
                            color="blue.200"
                        >
                            Selecione a partir do computador
                        </Text>
                        <Text 
                            color="gray.400"
                            fontSize=".7rem"
                        >
                            Arquivo deve estar no formato *.csv
                        </Text>
                    </Flex>
                )}
            </Dragger>
            {errors.length >= 0 && (
                <>
                    <Heading fontSize="18px">Relatorio</Heading>
                    <Flex w="100%" bgColor="#FAFAFA" p={8} direction="column">
                        {errors?.length > 0 && (
                            <Stack>
                                <Text color="#8E1E1E">Errors: </Text>
                                {errors.map((error) => (
                                    <Text key={error.code} color="#8E1E1E">
                                    - {error.description}
                                    </Text>
                                ))}
                            </Stack>
                        )}
                        {status === "success" && (
                            <Text>- Importação realizada com sucesso! ✅</Text>
                        )}
                    </Flex>
                </>
            )}
        </FormModal>
    )
}